/* ============================================================
   JUSTYOL — Reviews renderer
   Reads the real Judge.me data out of the server-rendered widget
   (product.metafields.judgeme.widget) and re-renders it into the on-brand
   .jy-rv box: summary card (average, recommend %, histogram) + review cards.
   This also removes Judge.me's infinite loading spinners (which spin forever
   when the app-embed script isn't hydrating), so it's a perf win too.
   No network calls — everything comes from the already-present DOM.
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  var AVA_BG = ['#f0e7df', '#e7eef0', '#efe7f0', '#e7f0ea', '#f0ece0', '#e7ecf0'];

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function starsHtml(pct) {
    return (
      '<span class="jy-stars" style="--jy-rate:' +
      pct +
      '%" aria-hidden="true"><span class="jy-stars__fill">★★★★★</span>★★★★★</span>'
    );
  }

  function fmtDate(raw, locale) {
    if (!raw) return '';
    // Judge.me ships "2025-07-23 22:00:00 UTC"
    var d = new Date(raw.replace(' UTC', 'Z').replace(' ', 'T'));
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) {
      return d.getFullYear() + '';
    }
  }

  function num(el, attr) {
    if (!el) return 0;
    var v = parseFloat(el.getAttribute(attr));
    return isNaN(v) ? 0 : v;
  }

  function buildBox(widg, isAr) {
    var locale = isAr ? 'ar-MA' : 'fr-FR';
    var t = {
      reviews: isAr ? 'تقييم' : 'avis',
      recommend: isAr ? 'من العملاء ينصحون بهذا المنتج' : 'des clients recommandent ce produit',
      verified: isAr ? 'تقييمات موثّقة' : 'Avis vérifiés',
      cod: isAr ? 'الدفع عند الاستلام' : 'Achat COD',
      more: isAr ? 'عرض المزيد من التقييمات' : "Voir plus d'avis",
    };

    var avg = num(widg, 'data-average-rating');
    var total = Math.round(num(widg, 'data-number-of-reviews'));
    if (total <= 0) return null;

    // histogram
    var rows = widg.querySelectorAll('.jdgm-histogram__row[data-rating]');
    var freq = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    var pctOf = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    Array.prototype.forEach.call(rows, function (r) {
      var rt = parseInt(r.getAttribute('data-rating'), 10);
      if (rt >= 1 && rt <= 5) {
        freq[rt] = Math.round(num(r, 'data-frequency'));
        pctOf[rt] = Math.round(num(r, 'data-percentage'));
      }
    });
    var recommendPct = total ? Math.round(((freq[5] + freq[4]) / total) * 100) : 0;

    // reviews
    var revEls = widg.querySelectorAll('.jdgm-rev');
    var reviews = [];
    Array.prototype.forEach.call(revEls, function (r) {
      var ratingEl = r.querySelector('.jdgm-rev__rating');
      var score = ratingEl ? num(ratingEl, 'data-score') : 0;
      if (!score) score = r.querySelectorAll('.jdgm-rev__rating .jdgm--on').length;
      var authorEl = r.querySelector('.jdgm-rev__author');
      var author = authorEl ? authorEl.textContent.trim() : '';
      var bodyEl = r.querySelector('.jdgm-rev__body');
      var body = bodyEl ? bodyEl.textContent.trim() : '';
      var iconEl = r.querySelector('.jdgm-rev__icon');
      var initial = (iconEl ? iconEl.textContent.trim() : author).charAt(0).toUpperCase() || '★';
      var tsEl = r.querySelector('.jdgm-rev__timestamp');
      var date = fmtDate(tsEl ? tsEl.getAttribute('data-content') : '', locale);
      var locEl = r.querySelector('.jdgm-rev__location');
      var loc = locEl ? locEl.textContent.trim() : '';
      var verified = r.getAttribute('data-verified-buyer') === 'true';
      var pics = [];
      Array.prototype.forEach.call(r.querySelectorAll('.jdgm-rev__pic-img'), function (img) {
        var thumb = img.getAttribute('data-src') || img.getAttribute('src');
        if (!thumb) return;
        // Judge.me wraps the thumb in a link to the full-size image; fall back
        // to the thumb when no larger source exists.
        var link = img.closest('a');
        var full = (link && link.getAttribute('href')) || img.getAttribute('data-full') || thumb;
        pics.push({ thumb: thumb, full: full });
      });
      if (author || body) {
        reviews.push({
          score: score,
          author: author,
          body: body,
          initial: initial,
          date: date,
          loc: loc,
          verified: verified,
          pics: pics,
        });
      }
    });

    var box = document.createElement('div');
    box.className = 'jy-rv';

    // ---- summary card ----
    var hist = '';
    [5, 4, 3, 2, 1].forEach(function (s) {
      hist +=
        '<div class="jy-rv__hrow"><span class="jy-rv__hlabel">' +
        s +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg></span>' +
        '<span class="jy-rv__hbar"><i style="width:' +
        pctOf[s] +
        '%"></i></span><span class="jy-rv__hpct">' +
        pctOf[s] +
        '%</span></div>';
    });

    box.innerHTML =
      '<div class="jy-rv__summary">' +
      '<div class="jy-rv__score">' +
      '<div class="jy-rv__avg">' +
      avg.toFixed(1).replace('.', isAr ? '٫' : ',') +
      '</div>' +
      starsHtml((avg / 5) * 100) +
      '<div class="jy-rv__count">' +
      total.toLocaleString(locale) +
      ' ' +
      t.reviews +
      '</div>' +
      '</div>' +
      (recommendPct > 0
        ? '<div class="jy-rv__recommend"><b>' +
          recommendPct +
          '%</b> ' +
          t.recommend +
          '</div>'
        : '') +
      '<div class="jy-rv__hist">' +
      hist +
      '</div>' +
      '<div class="jy-rv__verified"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' +
      t.verified +
      '</div>' +
      '</div>';

    // ---- review cards ----
    var list = document.createElement('ul');
    list.className = 'jy-rv__list';
    var CAP = 4;
    reviews.forEach(function (rv, i) {
      var li = document.createElement('li');
      li.className = 'jy-rv__item' + (i >= CAP ? ' is-hidden' : '');
      var bg = AVA_BG[i % AVA_BG.length];
      var meta = [];
      if (rv.loc) meta.push('<span class="jy-rv__loc">' + esc(rv.loc) + '</span>');
      var picsHtml = '';
      if (rv.pics.length) {
        picsHtml = '<div class="jy-rv__pics">';
        rv.pics.slice(0, 4).forEach(function (p) {
          picsHtml +=
            '<button type="button" class="jy-rv__pic" data-jy-rvpic data-full="' +
            esc(p.full) +
            '" aria-label="' +
            (isAr ? 'تكبير الصورة' : 'Agrandir la photo') +
            '">' +
            '<img loading="lazy" src="' +
            esc(p.thumb) +
            '" alt="" width="64" height="64">' +
            '</button>';
        });
        picsHtml += '</div>';
      }
      li.innerHTML =
        '<div class="jy-rv__head">' +
        '<span class="jy-rv__ava" style="background:' +
        bg +
        '">' +
        esc(rv.initial) +
        '</span>' +
        '<div class="jy-rv__who">' +
        '<div class="jy-rv__name">' +
        esc(rv.author) +
        (rv.verified
          ? '<svg class="jy-rv__chk" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12.5l2.5 2.5 5-5.5"/></svg>'
          : '') +
        '</div>' +
        '<div class="jy-rv__sub">' +
        (rv.loc ? '<span class="jy-rv__loc">' + esc(rv.loc) + '</span> · ' : '') +
        starsHtml((rv.score / 5) * 100) +
        (rv.date ? '<span class="jy-rv__date">' + esc(rv.date) + '</span>' : '') +
        '</div>' +
        '</div>' +
        '<span class="jy-rv__cod">' +
        t.cod +
        '</span>' +
        '</div>' +
        (rv.body ? '<p class="jy-rv__body">' + esc(rv.body) + '</p>' : '') +
        picsHtml;
      list.appendChild(li);
    });
    box.appendChild(list);

    // ---- "see more" toggle (client-side, reviews already parsed) ----
    if (reviews.length > CAP) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'jy-rv__more';
      btn.textContent = t.more + ' (' + (reviews.length - CAP) + ')';
      btn.addEventListener('click', function () {
        list.querySelectorAll('.jy-rv__item.is-hidden').forEach(function (el) {
          el.classList.remove('is-hidden');
        });
        btn.remove();
      });
      box.appendChild(btn);
    }

    return box;
  }

  /* ---- review-photo lightbox (click to zoom, desktop + mobile) ---- */
  function setupRvLightbox() {
    var lbx = null;
    var img = null;

    function build() {
      lbx = document.createElement('div');
      lbx.className = 'jy-rvlbx';
      lbx.hidden = true;
      lbx.innerHTML =
        '<button type="button" class="jy-rvlbx__close" aria-label="Close">&times;</button>' +
        '<img class="jy-rvlbx__img" alt="">';
      img = lbx.querySelector('.jy-rvlbx__img');
      document.body.appendChild(lbx);

      // click the backdrop (not the image) closes; clicking the image toggles zoom
      lbx.addEventListener('click', function (e) {
        if (e.target === img) {
          lbx.classList.toggle('is-zoom');
        } else {
          close();
        }
      });
    }

    function open(src) {
      if (!lbx) build();
      img.src = src;
      lbx.classList.remove('is-zoom');
      lbx.hidden = false;
      document.documentElement.classList.add('jy-sheet-lock');
    }
    function close() {
      if (!lbx) return;
      lbx.hidden = true;
      lbx.classList.remove('is-zoom');
      img.removeAttribute('src');
      document.documentElement.classList.remove('jy-sheet-lock');
    }

    // delegate: works for any enhanced review box, now or later
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-jy-rvpic]');
      if (!btn) return;
      e.preventDefault();
      var full = btn.getAttribute('data-full');
      if (full) open(full);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  ready(function () {
    var wraps = document.querySelectorAll('[data-jy-reviews]');
    Array.prototype.forEach.call(wraps, function (wrap) {
      try {
        var widg = wrap.querySelector('.jdgm-rev-widg');
        var target = wrap.querySelector('[data-jy-rv-target]');
        if (!widg || !target) return;
        var isAr =
          document.documentElement.getAttribute('dir') === 'rtl' ||
          !!(wrap.closest('[data-jy-pdp]') && wrap.closest('[data-jy-pdp]').hasAttribute('data-jy-ar'));
        var box = buildBox(widg, isAr);
        if (!box) return; // no real reviews → leave as-is
        target.innerHTML = '';
        target.appendChild(box);
        target.hidden = false;
        wrap.classList.add('is-enhanced');
      } catch (e) {
        /* on any failure, leave the raw widget visible as a fallback */
        if (window.console) console.warn('[jy-reviews]', e);
      }
    });
    setupRvLightbox();
  });
})();
